import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import '../Styles/CheckoutPayment.css';

const CheckoutCancel = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const sessionId = searchParams.get('session_id');

    useEffect(() => {
        // Verify that session_id exists
        if (!sessionId) {
            navigate('/');
            return;
        }
    }, [sessionId, navigate]);

    if (!sessionId) {
        return null; // Will redirect in useEffect
    }

    return (
        <div className="checkout-payment-container cancel">
            <div className="payment-card">
                <div className="cancel-icon">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="15" y1="9" x2="9" y2="15"></line>
                        <line x1="9" y1="9" x2="15" y2="15"></line>
                    </svg>
                </div>

                <h1>Payment Cancelled</h1>
                <p className="subtitle">Your payment was not completed</p>

                <div className="message-content">
                    <p>
                        Your payment has been cancelled. No charges were made to your account.
                    </p>
                    <p style={{ marginTop: '20px', fontSize: '16px', color: '#666' }}>
                        You can close this window.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default CheckoutCancel;
